const resourcesBasePath = './resources/';
export const requireResource = (fileName: string): any => require(`${resourcesBasePath}${fileName}`);

export const requireResources: (resourcesFileNames: string[]) => string[] = (resourcesFileNames: string[]) =>
    resourcesFileNames.map((fileName) => requireResource(fileName));
